<template>
    <div class="row" v-if="user">
        <div class="col">

            <breadcrumb :transparent="true">
                <breadcrumb-item>
                    <router-link to="/xlrs/accounts/users">
                        {{ $t('common.users') }}
                    </router-link>
                </breadcrumb-item>
                <breadcrumb-item active>
                    {{ user.name }}
                </breadcrumb-item>
            </breadcrumb>

            <agents-crud></agents-crud>
        </div>
    </div>
</template>

<script>
    import AgentsCrud from './agents/AgentsCrud';

    export default {

        components: {
            AgentsCrud
        },

        data() {
            return {
                user: null
            }
        },

        beforeRouteEnter(to, from, next) {
            axios.get('/trax/api/front/users/'+to.params.id)
            .then(resp => {
                next(vm => {
                    vm.user = resp.data.data
                    next()
                })
            });
        }
    }
</script>
